export default __webpack_public_path__ + "static/media/rc_team.8fb98342.png";